/* eslint no-unused-vars: 0 */

import React from "react"

class AdminSearchInstructions extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      mode: "product"
    };
    this.setDisplayMode = this.setDisplayMode.bind(this);
  }

  setDisplayMode(mode) {
    this.setState({
      mode
    });
  }

  render() {
    var table_body =
      this.state.mode === "product" ? (
        <tbody>
          {this.props.recently_updated_products.map((product, index) => {
            return (
              <tr key={index}>
                <td>
                  <span className="search-term">{product.term}</span>
                </td>
                <td>{product.count[product.term]}</td>
                <td>{product.updated_at}</td>
                <td>
                  <button
                    onClick={() => {
                      this.props.setSearchTerm(product.term, "Product");
                    }}
                  >
                    Edit
                  </button>
                </td>
              </tr>
            );
          })}
        </tbody>
      ) : (
        <tbody>
          {this.props.recently_updated_product_categories.map((product_category, index) => {
            return (
              <tr key={index}>
                <td>
                  <span className="search-term">{product_category.term}</span>
                </td>
                <td>{product_category.count[product_category.term]}</td>
                <td>{product_category.updated_at}</td>
                <td>
                  <button
                    onClick={() => {
                      this.props.setSearchTerm(product_category.term, "Product Category");
                    }}
                  >
                    Edit
                  </button>
                </td>
              </tr>
            );
          })}
        </tbody>
      );
    return (
      <div className="admin-search-instructions">
        <div className="row">
          <div className="span6">
            <h1>Instructions on how to use promoted search....</h1>
            <p>
              Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vivamus
              varius dui justo, vitae elementum felis egestas vitae. Donec
              tincidunt interdum urna at ultrices. Etiam nibh erat, iaculis
              venenatis nulla egestas, tempus lobortis ante. Vivamus malesuada
              mauris odio, in malesuada felis cursus nec. Curabitur auctor nisl
              sit amet sem ullamcorper ullamcorper. Suspendisse vel ultricies
              nisi. Suspendisse elementum quam arcu, nec scelerisque eros
              vehicula at. Nulla facilisi. Lorem ipsum dolor sit amet,
              consectetur adipiscing elit. Donec eros est, elementum ac
              consequat sed, porttitor nec sem. Nullam eu turpis sed odio
              fermentum tincidunt.
            </p>
            <p>
              Maecenas ut diam vitae lacus mattis lacinia. Nullam id pretium
              turpis, at aliquet nibh. Proin posuere justo sit amet libero
              ultricies suscipit. Duis sit amet sapien id tortor laoreet commodo
              sit amet non purus. Vivamus vel tincidunt lacus. Pellentesque
              habitant morbi tristique senectus et netus et malesuada fames ac
              turpis egestas. Nunc rutrum eros sem, sed vehicula est dictum
              vitae. Pellentesque tristique porta ultrices. Vestibulum nec
              tellus pharetra, aliquam tellus sit amet, placerat metus.
              Phasellus quis sem diam. Aliquam euismod mauris vitae nisl
              imperdiet, ac pellentesque felis ultricies.
            </p>

            <p>
              In hac habitasse platea dictumst. Pellentesque sagittis turpis et
              odio egestas, vitae interdum enim ornare. Nunc efficitur porttitor
              efficitur. Curabitur scelerisque semper pellentesque. Integer
              facilisis ullamcorper nisi quis mattis. Aenean consequat
              vestibulum odio eget venenatis. Vestibulum condimentum vel justo
              vel sagittis. Nam accumsan accumsan dignissim. Sed porta nulla at
              turpis commodo, sit amet placerat orci placerat. Ut aliquam diam
              sit amet aliquam elementum.
            </p>
          </div>
          <div className="span6">
            <h1>Recent Terms Updated</h1>
            <span
              className={
                "toggle-recent " +
                (this.state.mode === "product category" ? "inactive" : "")
              }
              onClick={() => {
                this.setDisplayMode("product");
              }}
            >
              Products -{" "}
              <span className="count">
                {this.props.recently_updated_products.length}
              </span>
            </span>
            <span
              className={
                "toggle-recent " +
                (this.state.mode === "product" ? "inactive" : "")
              }
              onClick={() => {
                this.setDisplayMode("product category");
              }}
            >
              Product Categories -{" "}
              <span className="count">
                {this.props.recently_updated_product_categories.length}
              </span>
            </span>
            <table className="recently-updated--terms">
              <thead>
                <tr>
                  <th>Term</th>
                  <th>Promotions</th>
                  <th>Last Updated</th>
                  <th>Edit</th>
                </tr>
              </thead>
              {table_body}
            </table>
          </div>
        </div>
      </div>
    );
  }
}

export default AdminSearchInstructions;
